interface Props {
	size?: number;
}

export function ClockIcon({size = 16}: Props) {
	return (
		<svg width={size} height={size} viewBox="0 0 20 20" fill="currentColor" role="img" aria-hidden="true">
			<path
				fillRule="evenodd"
				d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-13a.75.75 0 00-1.5 0v5c0 .414.336.75.75.75h4a.75.75 0 000-1.5h-3.25V5z"
				clipRule="evenodd"
			/>
		</svg>
	);
}
